<template>
  <div class="search-header" :class="{ disabled }">
    <Input
      class="search-header__input"
      :value.sync="searchQuery"
      :placeholder="placeholder"
    />
    <Button
      skin="primary"
      :padding="30"
      @click.native="initSearch"
    >
      {{ $t(`general.find`) }}
    </Button>
  </div>
</template>

<script>
import Button from '@/manzana_library/components/Elements/Button';
import Input from '@/manzana_library/components/Elements/Input';

export default {
  name: "SearchHeader",
  components: {
    Button,
    Input
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
    }
  },
  data() {
    return {
      searchQuery: ""
    }
  },

  watch: {
    searchQuery(next) {
      this.$emit("update:value", next);
    }
  },

  methods: {
    initSearch() {
      this.$emit("init-search", this.searchQuery);
      this.searchQuery = "";
    }
  }
}
</script>

<style lang="scss">
.search-header {
  display: flex;
  width: 100%;
  &__input.input {
    width: calc(100% - 120px) !important;
    margin-right: 10px;
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
